import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  StatusFormatter,
  formLabelsTheme,
  formatDate,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";
import paginationFactory from "react-bootstrap-table2-paginator";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicle,
  fetchVehicle,
  fetchVehicleOutbound,
} from "../inbound/inboundSlice";
import {
  addOutboundVehicle,
  fetchIdOutbound,
  fetchOutboundParty,
  fetchOutboundPartyAll,
  fetchOutboundVehicle,
  selectIdOutbound,
  selectOutboundPartyAll,
} from "./outboundSlice";
import { Autocomplete } from "@material-ui/lab";
import { FormHelperText } from "@material-ui/core";
import {
  fetchBookingPartyAll,
  selectBookingPartyAll,
} from "../booking/bookingSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ModalCreateVehicle = ({
  isOpen,
  setShow,
  formValues,
  setFormValues,
  setFields,
  fields,
  getData,
  setGetData,
  selectedRows,
  setSelectedRows,
  formFilterModal,
  setFormFilterModal,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataId = useSelector(selectIdOutbound);
  const data = useSelector(selectVehicle);
  const dataPartyAll = useSelector(selectOutboundPartyAll);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const [tableData, setTableData] = useState(data);
  const paginationSet = useSelector(selectPagination);
  const { id } = useParams();

  console.log(dataId, "dataId");

  // initial

  useEffect(() => {
    // Add number
    if (data !== null) {
      const pageBefore = pageSize * (pageNo - 1);
      const initData = data.map((item, index) => {
        return {
          ...item,
          no: index + 1 + pageBefore,
        };
      });
      setTableData(initData);
    }
  }, [data, pageSize, pageNo]);

  useEffect(() => {
    if (getData === true) {
      handleSearch();
      dispatch(
        fetchOutboundPartyAll({
          outbound_id: id,
          party_carrier: "CARRIER",
          pageNo: 1,
          pageSize: -1,
        })
      );
      setGetData(false);
    }
  }, [getData]);

  const handleSearch = async () => {
    if (
      (formFilterModal.booking_date_start.value &&
        !formFilterModal.booking_date_end.value) ||
      (formFilterModal.booking_date_end.value &&
        !formFilterModal.booking_date_start.value)
    ) {
      return showErrorDialog(
        "Please fill in both date filters: From Date and Until Date."
      );
    }

    if (
      (formFilterModal.rsd_start.value && !formFilterModal.rsd_end.value) ||
      (formFilterModal.rsd_end.value && !formFilterModal.rsd_start.value)
    ) {
      return showErrorDialog(
        "Please fill in both date filters: From Date and Until Date."
      );
    }

    if (
      (formFilterModal.rad_start.value && !formFilterModal.rad_end.value) ||
      (formFilterModal.rad_end.value && !formFilterModal.rad_start.value)
    ) {
      return showErrorDialog(
        "Please fill in both date filters: From Date and Until Date."
      );
    }

    let params = {
      booking_date_start: formFilterModal.booking_date_start.value,
      booking_date_end: formFilterModal.booking_date_end.value,
      rsd_start: formFilterModal.rsd_start.value,
      rsd_end: formFilterModal.rsd_end.value,
      rad_start: formFilterModal.rad_start.value,
      rad_end: formFilterModal.rad_end.value,
    };
    fields.forEach((item) => {
      params[item.params] = item.value;
    });
    params.vehicle_status = "6030";
    params.client = dataId.client;
    // params.is_outbound = "N";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchVehicleOutbound(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        booking_date_start: formFilterModal.booking_date_start.value,
        booking_date_end: formFilterModal.booking_date_end.value,
        rsd_start: formFilterModal.rsd_start.value,
        rsd_end: formFilterModal.rsd_end.value,
        rad_start: formFilterModal.rad_start.value,
        rad_end: formFilterModal.rad_end.value,
      };
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      params.vehicle_status = "6030";
      params.client = dataId.client;
      // params.is_outbound = "N";
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchVehicleOutbound(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // params

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "booking_no",
      label: "Booking No",
      show: "Y",
      editor: "text",
    },
    {
      id: "1",
      value: "dealer_code",
      label: "Dealer",
      show: "Y",
      editor: "text",
    },
    {
      id: "1",
      value: "vin",
      label: "VIN",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "von",
      label: "VON",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "delivery_arrangement",
      label: "Delivery Arrangement",
      show: "Y",
      editor: "text",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "130px" },
    },

    {
      text: "Booking No.",
      dataField: "booking_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Delivery Arrangement",
      dataField: "delivery_arrangement",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Client",
      dataField: "client_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "100px" },
    },
    {
      text: "Booking Date",
      dataField: "booking_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "100px" },
    },
    {
      text: "RSD",
      dataField: "rsd",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "100px" },
    },
    {
      text: "RAD",
      dataField: "rad",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "100px" },
    },
    {
      text: "Dealer Code",
      dataField: "dealer_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Dealer Name",
      dataField: "dealer_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Accessories Installed",
      dataField: "inbound_rule",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: StatusFormatter,
      headerAlign: "center",
    },
  ];

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const handleClose = () => {
    setSelectedRows([]);
    setFormValues({
      party_id: {
        value: "",
        error: false,
        required: "N",
      },
      party_name: {
        value: "",
        error: false,
        required: "N",
      },
      party_code: {
        value: "",
        error: false,
        required: "N",
      },
      timezone: {
        value: "",
        error: false,
        required: "N",
      },
    });
    setFields([
      {
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      },
    ]);

    setShow(false);
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async (e) => {
    if (!validatePost()) {
      return;
    }

    if (selectedRows.length < 1) {
      return showDialog("Please input Vehicle");
    }

    const params = selectedRows.map((item, index) => {
      return {
        outbound_id: id,
        vehicle_id: item.vehicle_id,
        picking_timezone: formValues.timezone.value,
        party_id: formValues.party_id.value,
        is_booking: "N",
      };
    });

    console.log(params, "params");

    try {
      const response = await dispatch(addOutboundVehicle(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(
          fetchOutboundVehicle({
            outbound_id: id,
            pageNo: 1,
            pageSize: paginationSet,
          })
        );
        await dispatch(fetchIdOutbound(id));
        await handleClose();
        await window.scrollTo(0, 1500);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const onSelectRow = {
    mode: "checkbox",
    onSelectAll: (status) => {
      if (status === true) {
        setSelectedRows([...tableData]);
      } else {
        setSelectedRows([]);
      }
    },
    onSelect: (row, isSelect, rowIndex) => {
      if (isSelect) {
        setSelectedRows((prevSelectedRows) => [...prevSelectedRows, row]);
      } else {
        setSelectedRows((prevSelectedRows) => {
          const index = prevSelectedRows.findIndex(
            (selectedRow) => selectedRow.vehicle_id === row.vehicle_id
          );
          if (index > -1) {
            const newSelectedRows = [...prevSelectedRows];
            newSelectedRows.splice(index, 1);
            return newSelectedRows;
          }
          return prevSelectedRows;
        });
      }
    },
  };

  const handleChangeParty = (e, newValue) => {
    if (newValue === null) {
      setFormValues({
        ...formValues,
        ["party_id"]: {
          ...formValues["party_id"],
          value: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        ["party_id"]: {
          ...formValues["party_id"],
          value: newValue.value,
        },
      });
    }
  };

  const partyOptions = dataPartyAll.map((e) => {
    return {
      value: e.party_id,
      label: e.party + "-" + e.party_name,
    };
  });

  const indexParty = partyOptions.findIndex(
    (obj) => obj.value === formValues.party_id.value
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };
  const handleChangeFilter = (e) => {
    const { name, value } = e.target;
    setFormFilterModal({
      ...formFilterModal,
      [name]: {
        ...formFilterModal[name],
        value,
      },
    });
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Retrieve Vehicles
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <p className="font-weight-boldest">Basic Detail</p>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Row>
                  <Col xs={12} sm={3} md={5} lg={5}>
                    <RedditTextField
                      label="Booking Date From"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="booking_date_start"
                      onChange={handleChangeFilter}
                      value={formFilterModal.booking_date_start.value}
                    />
                  </Col>
                  <Col xs={1} sm={1} md={1} lg={1}>
                    <p className="text-center mt-5">To</p>
                  </Col>
                  <Col xs={12} sm={3} md={5} lg={5}>
                    <RedditTextField
                      label="Booking Date Until"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="booking_date_end"
                      onChange={handleChangeFilter}
                      value={formFilterModal.booking_date_end.value}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={3} md={5} lg={5}>
                    <RedditTextField
                      label="Request Shipping Date From"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="rsd_start"
                      onChange={handleChangeFilter}
                      value={formFilterModal.rsd_start.value}
                    />
                  </Col>
                  <Col xs={1} sm={1} md={1} lg={1}>
                    <p className="text-center mt-5">To</p>
                  </Col>
                  <Col xs={12} sm={3} md={5} lg={5}>
                    <RedditTextField
                      label="Request Shipping Date Until"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="rsd_end"
                      onChange={handleChangeFilter}
                      value={formFilterModal.rsd_end.value}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                <Row>
                  <Col xs={12} sm={3} md={5} lg={5}>
                    <RedditTextField
                      label="Request Arrival Date From"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="rad_start"
                      onChange={handleChangeFilter}
                      value={formFilterModal.rad_start.value}
                    />
                  </Col>
                  <Col xs={1} sm={1} md={1} lg={1}>
                    <p className="text-center mt-5">To</p>
                  </Col>
                  <Col xs={12} sm={3} md={5} lg={5}>
                    <RedditTextField
                      label="Request Arrival Date Until"
                      className={classes.margin}
                      variant="filled"
                      id="reddit-input"
                      type="date"
                      size="small"
                      fullWidth
                      name="rad_end"
                      onChange={handleChangeFilter}
                      value={formFilterModal.rad_end.value}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </ThemeProvider>
          {fields.map((field, idx) => {
            return (
              <div key={`${field}-${idx}`}>
                <Form.Group as={Row}>
                  <Form.Label column sm={2}>
                    {idx === 0 && <b>Search By</b>}
                  </Form.Label>

                  <Col sm={3}>
                    {fields[idx].add === "N" && (
                      <Select
                        // isClearable={true}
                        options={data_filter}
                        value={getValueType(field.params, typeOptions)}
                        placeholder="Select Field"
                        // onChange={handleTypeChange}
                        onChange={(e) => handleTypeChange(idx, e)}
                      />
                    )}
                    {fields[idx].add === "Y" && (
                      <Form.Control
                        type="text"
                        value={fields[idx].label}
                        disabled
                      />
                    )}
                  </Col>
                  <Col sm={3}>
                    {field.editor === "text" && (
                      <Form.Control
                        type="text"
                        placeholder="Enter text"
                        value={field.value || ""}
                        onChange={(e) => handleRemarkChange(idx, e)}
                      />
                    )}
                  </Col>
                  <Col sm={3} className=" m-0 p-0">
                    {fields[idx].remove === "Y" && (
                      <div
                        className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                        onClick={() => handleRemove(idx)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-light">
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                          />
                        </span>
                      </div>
                    )}

                    {btnHide === false && fields.length - 1 === idx && (
                      <Button
                        className="mr-3"
                        variant="outline-primary"
                        onClick={(e) => handleAdd(idx, e)}
                      >
                        Add
                      </Button>
                    )}

                    {fields.length - 1 === idx && (
                      <Button
                        className="mr-3"
                        variant="primary"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                    )}
                  </Col>
                </Form.Group>
              </div>
            );
          })}
          <ThemeProvider theme={formLabelsTheme}>
            <Row>
              <Col xs={12} sm={3} md={6} lg={6}>
                <RedditTextField
                  label="Timezone"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  fullWidth
                  size="small"
                  type="text"
                  name="timezone"
                  value={formValues.timezone.value}
                  onChange={handleChange}
                />
              </Col>
              <Col xs={12} sm={3} md={6} lg={6}>
                {/* <RedditTextField
                  label="Carrier Code"
                  className={classes.margin}
                  variant="filled"
                  id="reddit-input"
                  fullWidth
                  size="small"
                  type="text"
                  name="party_code"
                  value={formValues.party_code.value}
                  onChange={handleChange}
                /> */}
                <Autocomplete
                  options={partyOptions}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={
                    partyOptions.find(
                      (option) => option.value === formValues.party_id.value
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    if (newValue === null) {
                      setFormValues({
                        ...formValues,
                        ["party_id"]: {
                          ...formValues["party_id"],
                          value: "",
                        },
                      });
                    } else {
                      setFormValues({
                        ...formValues,
                        ["party_id"]: {
                          ...formValues["party_id"],
                          value: newValue.value,
                        },
                      });
                    }
                  }}
                  renderInput={(params) => (
                    <RedditTextField
                      className={classes.margin}
                      {...params}
                      label="Carrier"
                      id="reddit-input"
                      size="small"
                      fullWidth
                      placeholder="Select"
                      name="party_id"
                    />
                  )}
                />
              </Col>
            </Row>
          </ThemeProvider>

          {data && data.length > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              keyField="vehicle_id"
              data={tableData}
              columns={columns}
              pagination={paginationFactory(options)}
              onTableChange={handleTableChange}
              selectRow={{
                ...onSelectRow,
                selected: selectedRows.map((row) => row.vehicle_id),
              }}
              hover
            >
              <PleaseWaitMessage entities={loading ? null : data} />
              <NoRecordsFoundMessage entities={loading ? null : data} />
            </BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
